import { Component, computed, effect, inject, input } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { QrCodesFacade } from '@app/store/qr-codes';
import { CodeComponent } from '../code/code.component';
import { LoaderComponent } from '../loader/loader.component';

@Component({
    selector: 'app-qr-code',
    templateUrl: './qr-code.component.html',
    styleUrls: ['./qr-code.component.css'],
    imports: [CodeComponent, LoaderComponent],
    host: {
        '[class.sm]': "size() === 'sm'",
    },
})
export class QrCodeComponent {
    private readonly sanitizer = inject(DomSanitizer);
    private readonly qrCodesFacade = inject(QrCodesFacade);

    /** QR endpoint url (built with a `@app/store/qr-codes` helper) — the component loads and caches it through the qr-codes store, showing a loader meanwhile. */
    readonly url = input.required<string>();
    readonly code = input.required<string>();

    /** Plate size: `md` (default, ~10rem) for standalone codes, `sm` (~7rem) for dense shelf grids. */
    readonly size = input<'sm' | 'md'>('md');

    protected readonly safeSvg = computed<SafeHtml | null>(() => {
        const raw = this.qrCodesFacade.cache()[this.url()];

        return raw ? this.sanitizer.bypassSecurityTrustHtml(raw) : null;
    });

    constructor() {
        effect(() => this.qrCodesFacade.loadQrCode(this.url()));
    }
}
